import { useQuery } from '@tanstack/react-query';

import { ReportSummaryInputs } from '@hcs/types';
import { hookEnabledError } from '@hcs/utils';

import { ReportApi } from '../api';

export const QUERY_KEY_ORG_REPORTS_SUMMARY = 'QUERY_KEY_ORG_REPORTS_SUMMARY';

export const useOrgReportsSummary = (
  reportSummaryInputs: ReportSummaryInputs,
) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_ORG_REPORTS_SUMMARY,
      reportSummaryInputs.startDate,
      reportSummaryInputs.endDate,
    ],

    queryFn: async () => {
      const { startDate, endDate } = reportSummaryInputs;
      if (!startDate || !endDate) {
        throw hookEnabledError(
          'useOrgReportsSummary',
          'startDate and endDate are required',
        );
      }
      const response = await ReportApi.fetchReportsSummary({
        startDate,
        endDate,
      });
      return response;
    },

    enabled:
      reportSummaryInputs.startDate && reportSummaryInputs.endDate
        ? true
        : false,
  });
};
